'use client';
import { useContext } from 'react';
import { Pages } from '@/src/interfaces/pages-route';
import CommercialvehicleloanRecourseCreate = Pages.CommercialvehicleloanRecourseCreate;
import {
  createPurchaseCreditCartRecourseProduct,
  createPurchaseDOBRecourseProduct,
  createPurchasePosRecourseProduct,
  createPurchaseSmeRecourseProduct,
} from '@/lib/data-layer/create-purchase-product';
import { DataLayerService, OriginalLocationEvent, PageDetailsEvent, PurchaseEvent } from '@/lib/data-layer/data-layer';
import { DataLayerPurchaseListName } from '@/lib/data-layer/types';
import { RecourseSearchParams } from '@/src/app/basvuru/[page]/yonlendirme/client.page';
import { responseForwardModel } from '@/src/interfaces/recourse-type';
import { DeviceContext } from '@/src/store/contexts/device-context';
import { OriginalLocationContext } from '@/src/store/contexts/original-location-context';
import { getDeviceOS } from './getDeviceOS';
import { getDeviceType } from './getDeviceType';
import { ComponentType, DeviceType, LoanType, RecourseStatusType } from '@/src/interfaces/data-contracts';
import { getComponentType } from './getComponentTypes';
import { postApplyFormAction } from '@/src/features/vehicle-loan/sorgulama/actions/actions';
import { getCookie } from 'cookies-next';
import {
  getCreditCardRecourseForwardQueryAction,
  getDobRecourseForwardQueryAction,
  getPosProductRecourseForwardQueryAction,
  getSmeRecourseForwardQueryAction,
  getVehicleRecourseForwardQueryAction,
  postRecourseCreditCardMutationAction,
  postRecourseDobMutationAction,
  postRecoursePosProductMutationAction,
  postRecourseSmeMutationAction,
} from '@/src/features/recourse/actions';

type RecourseParamsType = {
  query: RecourseSearchParams & { listtype?: keyof typeof LoanType };
  referrerUrl?: string;
};

let userTrackingId: string | undefined;

if (typeof document !== 'undefined') {
  try {
    const cookies = document.cookie.split(';');
    userTrackingId = cookies
      .map((cookie) => cookie.trim())
      .find((cookie) => cookie.startsWith('userTrackingId='))
      ?.split('=')[1];
  } catch (e) {
    console.warn('userTrackingId not found in cookies: ', e);
  }
}

const dataLayer = new DataLayerService();
export const useCreditRecourse = ({ query, referrerUrl }: RecourseParamsType) => {
  const { originalUrl } = useContext(OriginalLocationContext);
  const userAgent = useContext(DeviceContext);
  const { isBot } = useContext(DeviceContext);

  const creditCardRecourseForward = async (): Promise<responseForwardModel<'kredi-karti'>> => {
    const OperatingSystem = getDeviceOS(userAgent);
    const Device = getDeviceType(userAgent);
    const { id, ct } = query;

    const config = {
      data: {
        userTrackingId,
        productId: Number(id),
        referrerUrl,
        componentType: ct,
        device: Device,
      },
      headers: {
        recourseStatus: RecourseStatusType['Redirect'],
      },
    };

    debugger;
    // let handleRecoursePostData = await handleRecoursePost(config).unwrap();
    //@ts-ignore
    let handleRecoursePostData = await postRecourseCreditCardMutationAction(config);

    debugger;
    // const response = await handleRecourse({
    const response = await getCreditCardRecourseForwardQueryAction({
      params: {
        productId: Number(id),
      },
      query: {
        ProductId: Number(id),
        Component: ct as ComponentType,
        ChannelCampaignCode: getCookie('session.channelcampaigncode'),
        ChannelId: undefined,
        RecourseId: handleRecoursePostData.recourseId,
      },
      headers: {
        Device: Device as unknown as DeviceType,
        OperatingSystem: OperatingSystem as any,
      },
    });

    debugger;
    if (handleRecoursePostData) {
      let { page: recourseGetPageData, seoInfo: recourseGetSeoInfoData } = response;
      let {
        annualFee,
        productName,
        bankName,
        revenue,
        price,
        displayOrder,
        recourseId,
        productId,
        quantity,
        annualFeeText,
        page: { category: pageCategory },
      } = handleRecoursePostData as any;

      debugger;

      const purchaseProduct = await createPurchaseCreditCartRecourseProduct({
        product: {
          id: productId,
          productName: productName,
          bankName: bankName,
          brand: bankName,
          defaultAmount: price,
          displayOrder,
          quantity: quantity,
          metrics: {
            metric8: annualFee,
          },
          dimensions: {
            dimension8: annualFeeText,
          },
        },
        category: pageCategory,
        list: DataLayerPurchaseListName.CREDIT_CART_RECOURSE,
      });
      let virtualPageUrl = window.location.pathname + window.location.search;
      let prepareDataLayerData = {
        ...recourseGetPageData,
        ...recourseGetSeoInfoData,
        virtualPageUrl,
      };
      let eventLabel = pageCategory || '';
      let actionValueId = recourseId !== undefined && recourseId !== null ? `61_${recourseId}` : '';
      dataLayer.sendEvent(new OriginalLocationEvent(originalUrl ?? window.location.href.toString()));
      dataLayer.sendEvent(
        new PageDetailsEvent({ pageData: prepareDataLayerData, clientData: { HK_botStatus: isBot }, type: 'page' })
      );
      dataLayer.sendEvent(
        new PurchaseEvent(eventLabel, { id: actionValueId, revenue, currency: 'TRY' }, [purchaseProduct])
      );
    }
    return response;
  };

  return { creditCardRecourseForward };
};

export const usePosRecourse = ({ query, referrerUrl }: RecourseParamsType) => {
  const userAgent = useContext(DeviceContext);
  const { isBot } = useContext(DeviceContext);
  const { originalUrl } = useContext(OriginalLocationContext);

  const posProductForward = async (): Promise<responseForwardModel<'pos-cihazlari'>> => {
    const OperatingSystem = getDeviceOS(userAgent);
    const Device = getDeviceType(userAgent);
    const { productId, ct } = query;

    const config = {
      data: {
        referrerUrl,
        productId: Number(productId),
        componentType: ct as ComponentType,
        revenue: 0,
        price: 0,
        device: Device,
        userTrackingId,
      },
      headers: {
        recourseStatus: RecourseStatusType['Redirect'],
      },
    };

    let handleRecoursePostData = await postRecoursePosProductMutationAction(config);

    const response = await getPosProductRecourseForwardQueryAction({
      params: {
        productId: Number(productId),
      },
      query: {
        Component: ct as ComponentType,
        ChannelCampaignCode: getCookie('session.channelcampaigncode'),
        ChannelId: undefined,
        RecourseId: handleRecoursePostData.recourseId,
      },
      headers: {
        Device: Device as unknown as DeviceType,
        OperatingSystem: OperatingSystem as any,
      },
    });

    // let handleRecoursePostData = await handleRecoursePost(config).unwrap();
    //@ts-ignore
    if (handleRecoursePostData) {
      let { page: recourseGetPageData, seoInfo: recourseGetSeoInfoData } = response;
      let {
        productName,
        bankName,
        revenue,
        price,
        commissionRate,
        displayOrder,
        subscription,
        subscriptionText,
        recourseId,
        productId,
        quantity,
        isActiveRecourse,
        page: { category: pageCategory },
      } = handleRecoursePostData as any;

      const purchaseProduct = createPurchasePosRecourseProduct({
        product: {
          id: productId,
          productName: productName,
          bankName: bankName,
          brand: bankName,
          defaultAmount: price,
          displayOrder,
          quantity: quantity,
          metrics: {
            metric1: subscription,
            metric2: commissionRate,
          },
          dimensions: {
            dimension1: subscriptionText,
            dimension2: commissionRate,
            dimension9: isActiveRecourse,
          },
        },
        category: pageCategory,
        list: DataLayerPurchaseListName.POST_PRODUCT_RECOURSE,
      });
      let eventLabel = pageCategory || '';
      let actionValueId = recourseId !== undefined && recourseId !== null ? `64_${recourseId}` : '';
      let virtualPageUrl = window.location.pathname + window.location.search;
      let prepareDataLayerData = {
        ...recourseGetPageData,
        ...recourseGetSeoInfoData,
        virtualPageUrl,
      };
      // original location event should be sent before page details event (GAVirtual)
      dataLayer.sendEvent(new OriginalLocationEvent(originalUrl ?? window.location.href.toString()));
      dataLayer.sendEvent(
        new PageDetailsEvent({ pageData: prepareDataLayerData, clientData: { HK_botStatus: isBot }, type: 'page' })
      );
      dataLayer.sendEvent(
        new PurchaseEvent(eventLabel, { id: actionValueId, revenue, currency: 'TRY' }, [purchaseProduct])
      );
    }
    return response;
  };

  return { posProductForward };
};

export const useSmeRecourse = ({ query, referrerUrl }: RecourseParamsType) => {
  const userAgent = useContext(DeviceContext);
  const { isBot } = useContext(DeviceContext);
  const { originalUrl } = useContext(OriginalLocationContext);
  const smeForward = async (): Promise<responseForwardModel<'kobi'>> => {
    const OperatingSystem = getDeviceOS(userAgent);
    const Device = getDeviceType(userAgent);
    const { id, amount, maturity, ct } = query;

    const config = {
      data: {
        referrerUrl,
        amount,
        maturity,
        componentType: ct,
        productId: id,
        userTrackingId,
      },
      headers: {
        recourseStatus: RecourseStatusType['Redirect'],
      },
    };

    //POST
    // let handleRecoursePostData = await handleRecoursePost(config).unwrap();
    //@ts-ignore
    let handleRecoursePostData = await postRecourseSmeMutationAction(config);

    //GET
    // const response = await handleRecourse({
    const response = await getSmeRecourseForwardQueryAction({
      params: {
        //@ts-ignore
        productId: id,
      },
      query: {
        Amount: parseInt(amount ?? '0'),
        Maturity: parseInt(maturity ?? '0'),
        Component: ct as ComponentType,
        ChannelCampaignCode: getCookie('session.channelcampaigncode'),
        ChannelId: undefined,
        RecourseId: handleRecoursePostData.recourseId,
      },
      headers: {
        Device: Device as unknown as DeviceType,
        OperatingSystem: OperatingSystem as any,
      },
    });

    if (handleRecoursePostData) {
      let { page: recourseGetPageData, seoInfo: recourseGetSeoInfoData } = response;
      let {
        productName,
        bankName,
        revenue,
        price,
        amount,
        maturity,
        interestRate,
        expenseAmount,
        displayOrder,
        monthlyInstallment,
        totalAmount,
        recourseId,
        productId,
        interestAmount,
        interestAmountText,
        annualCostRate,
        quantity,
        isActiveRecourse,
        monthlyInstallmentText,
        interestRateText,
        expenseAmountText,
        totalAmountText,
        annualCostRateText,
        page: { category: pageCategory },
        loanType,
      } = handleRecoursePostData as any;

      productName = loanType === 1 ? `${productName} - Tarim` : productName;

      const purchaseProduct = await createPurchaseSmeRecourseProduct({
        product: {
          id: productId,
          productName: productName,
          bankName: bankName,
          brand: bankName,
          defaultAmount: price,
          displayOrder,
          quantity: quantity,
          metrics: {
            metric1: monthlyInstallment,
            metric2: interestRate,
            metric3: interestAmount,
            metric4: expenseAmount,
            metric5: maturity,
            metric6: totalAmount,
            metric7: annualCostRate,
          },
          dimensions: {
            dimension9: isActiveRecourse,
            dimension1: monthlyInstallmentText,
            dimension2: interestRateText,
            dimension3: interestAmountText,
            dimension4: expenseAmountText,
            dimension5: maturity,
            dimension6: totalAmountText,
            dimension7: annualCostRateText,
          },
          maturity: maturity,
          amount: amount,
        },
        category: pageCategory,
        list: DataLayerPurchaseListName.SME_RECOURSE,
      });
      let eventLabel = pageCategory || '';
      let actionValueId = recourseId !== undefined && recourseId !== null ? `60_${recourseId}` : '';
      let virtualPageUrl = window.location.pathname + window.location.search;
      let prepareDataLayerData = {
        ...recourseGetPageData,
        ...recourseGetSeoInfoData,
        virtualPageUrl,
      };
      dataLayer.sendEvent(new OriginalLocationEvent(originalUrl ?? window.location.href.toString()));
      dataLayer.sendEvent(
        new PageDetailsEvent({ pageData: prepareDataLayerData, clientData: { HK_botStatus: isBot }, type: 'page' })
      );
      dataLayer.sendEvent(
        new PurchaseEvent(eventLabel, { id: actionValueId, revenue, currency: 'TRY' }, [purchaseProduct])
      );
    }
    return response;
  };

  return { smeForward };
};

export const useDobRecourse = ({ query, referrerUrl }: RecourseParamsType) => {
  const userAgent = useContext(DeviceContext);
  const { isBot } = useContext(DeviceContext);
  const { originalUrl } = useContext(OriginalLocationContext);
  const dobForward = async (): Promise<responseForwardModel<'uzaktan-musteri-edinimi'>> => {
    const OperatingSystem = getDeviceOS(userAgent);
    const Device = getDeviceType(userAgent);
    const { productId, ct } = query;

    //POST
    let headersPOST = {
      recourseStatus: 2,
    };

    let bodyPOST = {
      productId,
      userTrackingId,
    };

    const configPOST = {
      data: bodyPOST,
      headers: headersPOST,
    };

    //@ts-ignore
    let handleRecoursePostData = await postRecourseDobMutationAction(configPOST);

    const response = await getDobRecourseForwardQueryAction({
      params: {
        productId: productId as any,
      },
      query: {
        Component: ct as ComponentType,
        ChannelCampaignCode: getCookie('session.channelcampaigncode'),
        ChannelCampaignId: undefined,
        RecourseId: handleRecoursePostData.recourseId,
      },
      headers: {
        Device: Device as unknown as DeviceType,
        OperatingSystem: OperatingSystem as any,
      },
    });

    debugger;
    if (handleRecoursePostData) {
      const purchaseProduct = await createPurchaseDOBRecourseProduct({
        product: {
          id: response?.recourseForward?.productId,
          productName: response?.recourseForward?.productName,
          bankName: response?.recourseForward?.bankName,
          brand: response?.recourseForward?.bankName,
          defaultAmount: 10,
          quantity: 1,
          dimensions: {
            dimension9: response?.recourseForward?.isContract,
          },
        },
        category: response?.page?.category ?? '',
        list: DataLayerPurchaseListName.DOB_RECOURSE,
      });

      let eventLabel = response?.page?.category ?? '';

      let recourseId = response?.recourseForward?.recourseId;
      let actionValueId =
        recourseId !== undefined && recourseId !== null ? `65_${response?.recourseForward?.recourseId}` : '';

      let virtualPageUrl = window.location.pathname + window.location.search;
      let prepareDataLayerData = {
        ...response.page,
        ...response.seoInfo,
        virtualPageUrl,
      };
      dataLayer.sendEvent(new OriginalLocationEvent(originalUrl ?? window.location.href.toString()));
      dataLayer.sendEvent(
        new PageDetailsEvent({ pageData: prepareDataLayerData, clientData: { HK_botStatus: isBot }, type: 'page' })
      );
      dataLayer.sendEvent(
        new PurchaseEvent(eventLabel, { id: actionValueId, revenue: 10, currency: 'TRY' }, [purchaseProduct])
      );
    }
    return response;
  };

  return { dobForward };
};

export const useVehicleLoanRecourse = ({ query, referrerUrl }: RecourseParamsType) => {
  const userAgent = useContext(DeviceContext);
  const { isBot } = useContext(DeviceContext);
  const { originalUrl } = useContext(OriginalLocationContext);
  const vehicleForward = async () => {
    const { id, amount, maturity, ct } = query;
    const OperatingSystem = getDeviceOS(userAgent);
    const Device = getDeviceType(userAgent);
    const Component = getComponentType(ct ?? '');

    const resBody: CommercialvehicleloanRecourseCreate.RequestBody & { recourseStatus: RecourseStatusType } = {
      amount: Number(amount),
      maturity: Number(maturity),
      componentType: ComponentType[Component],
      productId: Number(id),
      referrerUrl: referrerUrl,
      userTrackingId: userTrackingId,
      recourseStatus: RecourseStatusType.Redirect,
    };

    let response = await postApplyFormAction(null, resBody);

    let res = await getVehicleRecourseForwardQueryAction({
      params: {
        productId: id as string,
      },
      query: {
        Component: ComponentType[Component],
        Amount: Number(amount),
        Maturity: Number(maturity),
        RecourseId: response.recourseId,
        ChannelCampaignCode: getCookie('session.channelcampaigncode'),
      },
      headers: {
        //@ts-ignore
        Device: Device as unknown as DeviceType,
        OperatingSystem: OperatingSystem as any,
      },
    });
    const combinedRes = { ...res, recourseForward: res?.product };

    if (response) {
      const purchaseProduct = await createPurchaseSmeRecourseProduct({
        product: {
          productName: combinedRes?.recourseForward?.productName,
          bankName: combinedRes?.recourseForward?.bankName,
          id: combinedRes?.recourseForward?.productId,
          defaultAmount: 3,
          brand: combinedRes?.recourseForward?.bankName,
          metrics: {
            metric1: combinedRes?.recourseForward?.monthlyInstallment,
            metric2: combinedRes?.recourseForward?.rate,
            metric3: combinedRes?.recourseForward?.totalInterest,
            metric4: combinedRes?.recourseForward?.expenseAmount,
            metric5: combinedRes?.recourseForward?.maturity,
            metric6: combinedRes?.recourseForward?.totalAmount,
            // @ts-ignore
            metric7: combinedRes?.recourseForward?.annualCostRate,
          },
          dimensions: {
            // @ts-ignore
            dimension9: combinedRes?.recourseForward?.isContract,
            dimension1: combinedRes?.recourseForward?.monthlyInstallment,
            dimension2: combinedRes?.recourseForward?.rate,
            dimension3: combinedRes?.recourseForward?.totalInterest,
            // @ts-ignore
            dimension4: combinedRes?.recourseForward?.expenseAmount,
            dimension5: combinedRes?.recourseForward?.maturity,
            dimension6: combinedRes?.recourseForward?.totalAmount,
            // @ts-ignore
            dimension7: combinedRes.recourseForward.annualCostRate,
          },
        },
        category: combinedRes?.page?.category ?? '',
        list: DataLayerPurchaseListName.VEHICLE_RECOURSE,
      });

      let eventLabel = combinedRes?.page?.category ?? '';

      let recourseId = combinedRes?.recourseForward?.recourseId;
      let actionValueId =
        recourseId !== undefined && recourseId !== null ? `66_${combinedRes?.recourseForward?.recourseId}` : '';

      let virtualPageUrl = window.location.pathname + window.location.search;
      let prepareDataLayerData = {
        ...response.page,
        ...response.seoInfo,
        virtualPageUrl,
      };
      dataLayer.sendEvent(new OriginalLocationEvent(originalUrl ?? window.location.href.toString()));
      dataLayer.sendEvent(
        new PageDetailsEvent({ pageData: prepareDataLayerData, clientData: { HK_botStatus: isBot }, type: 'page' })
      );
      dataLayer.sendEvent(
        new PurchaseEvent(eventLabel, { id: actionValueId, revenue: 3, currency: 'TRY' }, [purchaseProduct])
      );
      return combinedRes;
    }
  };

  return { vehicleForward };
};
